export default __webpack_public_path__ + "static/media/check-circle.c9de43c7.svg";